import { useLogout } from "../lib/session";

export function NoAccessPage() {
  const logout = useLogout();

  return (
    <main className="flex min-h-screen items-center justify-center bg-paper px-4">
      <div className="max-w-md text-center">
        <h1 className="mb-3 font-serif text-2xl font-bold text-ink">No access yet</h1>
        <p className="mb-6 text-ink-soft">
          Your account is not linked to a role at this school. Ask your school administrator to
          assign one, then sign in again.
        </p>
        <button
          type="button"
          onClick={() => logout.mutate()}
          className="rounded border border-rule px-4 py-2 text-sm text-ink hover:border-accent"
        >
          Sign out
        </button>
      </div>
    </main>
  );
}
